import angular from 'angular';
import ChangeArrowComponent from './change-arrow.component';

const ChangeArrowModule = angular
    .module('control-room.commons.basic.components.change-arrow', [])
    .component('crChangeArrow', ChangeArrowComponent);

export default ChangeArrowModule;
